import React, { useContext, useState } from "react";
import { filtrationcontext } from "../../../context/Filtercontext";
import TableHeadItem from "../../Helpers/Table/TableHeadItem";
import trans from "../../../utils";

export default function SubUsersTableHeaders() {
  const { Sort, setSort } = useContext(filtrationcontext);
  const [hoveredColumn, setHoveredColumn] = useState(null);
  const Sorting = (type) => {
    setSort((prevSort) => ({
      type: type,
      value: !prevSort.value,
    }));
  };
  /**Sort={() => Sorting("name")}
		SortType={Sort.value}
		isHovered={hoveredColumn === "name"}
		onMouseEnter={() => setHoveredColumn("name")}
		onMouseLeave={() => setHoveredColumn(null)} */
  return (
    <>
      <div className="table-head-container">
        <div className={`table-head d-flex p-16`}>
          <TableHeadItem title={trans("Name")} />
          <TableHeadItem title={trans("role")} />
          <TableHeadItem title={trans("Type")} />
          <div className="fs-14 fw-400 text-capitalize table-element">
            {trans("Actions")}
          </div>
        </div>
      </div>
    </>
  );
}
